"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PatientInfoCard = PatientInfoCard;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _components = require("../../components");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function PatientInfoCard(_ref) {
  var children = _ref.children,
    title = _ref.title,
    _ref$badges = _ref.badges,
    badges = _ref$badges === void 0 ? [] : _ref$badges,
    actionContent = _ref.actionContent;
  function getBadge(params) {
    if (!params) {
      return;
    }
    var _params$type = params.type,
      type = _params$type === void 0 ? 'green' : _params$type,
      text = params.text;
    return /*#__PURE__*/_react.default.createElement(_components.MonumentTag, {
      type: type,
      key: text,
      className: "text-center"
    }, text);
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "--tag-patient-info-card rounded-[14px] bg-white"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "w-full py-[18px] px-[24px] flex justify-between items-center"
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "text-green1-65 tw-subtitle-sm-medium"
  }, title), /*#__PURE__*/_react.default.createElement("div", null, badges.map(function (badgeObj) {
    return getBadge(badgeObj);
  }), actionContent)), /*#__PURE__*/_react.default.createElement(_components.Divider, {
    className: "w-full border-grey-20"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "w-full p-[24px]"
  }, children));
}
PatientInfoCard.propTypes = {
  cardTitle: _propTypes.default.string,
  badges: _propTypes.default.arrayOf(_propTypes.default.shape({
    color: _propTypes.default.string,
    type: _propTypes.default.string
  })),
  actionContent: _propTypes.default.node
};